Ext.define('SA.view.LocationsNotFoundWindow', {
    alias: 'widget.locations-not-found-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-locations-not-found-window',
    includeOkBtn: true,
    title: 'Locations Not Found',

    bodyTpl: [
        '<div class="sa-locations-not-found-window-svg-wrap">',
            '<svg><use href="#sa-icon-warning"></use></svg>',
        '</div>',
        '<div>',
            '<p>',
                '<strong>Sorry, your import could not be completed.</strong> The following files contain locations that weren’t found:',
            '</p>',
            '<tpl for=".">',
                '<div class="sa-locations-not-found-window-file-item">',
                    '<tpl if="moreThanTenNotFound">',
                        '<strong>{fileName:htmlEncode}</strong> contains more than 10 locations that weren’t found, including:',
                    '<tpl else>',
                        '<strong>{fileName:htmlEncode}:</strong>',
                    '</tpl>',
                    '<ul>',
                        '<tpl for="locations"><li>{.:htmlEncode}</li></tpl>',
                    '</ul>',
                '</div>',
            '</tpl>',
        '</div>'
    ],

    afterRender() {
        this.callParent();

        this.refreshBodyMaxHeight();
    },

    beforeDestroy() {
        SA.Viewport.un('resize', this.refreshBodyMaxHeight, this, {buffer: 100});

        this.callParent();
    },

    getBodyItems() {
        var tpl = new Ext.XTemplate(this.bodyTpl);

        return {
            xtype: 'component',
            cls: 'sa-locations-not-found-window-body-content',
            html: tpl.apply(this.files.map(file => ({...file, moreThanTenNotFound: file.locations.length > 10})))
        };
    },

    initEvents() {
        this.callParent();

        SA.Viewport.on('resize', this.refreshBodyMaxHeight, this, {buffer: 100});
    },

    refreshBodyMaxHeight() {
        var bodyEl = this.el.down('.sa-locations-not-found-window-body'),
            maxHeight = Ext.getBody().getHeight() - this.getHeaderHeight() - this.getFooterHeight() - 20; 

        bodyEl.setStyle('maxHeight', maxHeight + 'px');

        this.setPagePosition(this.getAlignToXY(Ext.getBody(), 'c-c?')); 
    }
});